import {
  CLEAR_USER,

  DELETE_USER,
  DELETE_USER_ERROR,
  DELETE_USER_SUCCESS,

  GET_USER,
  GET_USER_ERROR,
  GET_USER_SUCCESS,

  GET_USERS,
  GET_USERS_ERROR,
  GET_USERS_SUCCESS,

  SEARCH_USERS,
  SEARCH_USERS_ERROR,
  SEARCH_USERS_SUCCESS,

  SAVE_USER,
  SAVE_USER_ERROR,
  SAVE_USER_SUCCESS,

  SAVE_PASSWORD,
  SAVE_PASSWORD_ERROR,
  SAVE_PASSWORD_SUCCESS,

  SAVE_USER_SIMPLE,
  SAVE_USER_SIMPLE_ERROR,
  SAVE_USER_SIMPLE_SUCCESS,

  GET_BOARD_MEMBER,
  GET_BOARD_MEMBER_ERROR,
  GET_BOARD_MEMBER_SUCCESS,

} from './constants';

export default {
  [CLEAR_USER](state) {
    state.user = {
      firstName: null,
      lastName: null,
      email: null,
      telephone: null,
      password: null,
      type: 'STANDARD',
      language: 'FR',
    };
    state.error = false;
    state.success = false;
    state.loading = false;
  },

  [DELETE_USER](state) {
    state.error = false;
    state.loading = true;
  },
  [DELETE_USER_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [DELETE_USER_SUCCESS](state) {
    state.user = false;
    state.loading = false;
  },

  [GET_USER](state) {
    state.user = false;
    state.error = false;
    state.loading = true;
  },
  [GET_USER_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_USER_SUCCESS](state, payload) {
    state.user = payload;
    state.loading = false;
  },

  [GET_USERS](state) {
    state.users = [];
    state.error = false;
    state.loading = true;
  },
  [GET_USERS_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_USERS_SUCCESS](state, payload) {
    state.users = payload;
    state.loading = false;
  },

  [GET_BOARD_MEMBER](state) {
    state.boardMembers = [];
    state.error = false;
    state.loading = true;
  },
  [GET_BOARD_MEMBER_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_BOARD_MEMBER_SUCCESS](state, payload) {
    state.boardMembers = payload;
    state.loading = false;
  },

  [SEARCH_USERS](state) {
    state.searchUsers = [];
    state.error = false;
    state.loading = true;
  },
  [SEARCH_USERS_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [SEARCH_USERS_SUCCESS](state, payload) {
    state.searchUsers = payload;
    state.loading = false;
  },

  [SAVE_USER](state) {
    state.error = false;
    state.formLoading = true;
    state.success = false;
  },
  [SAVE_USER_ERROR](state, payload) {
    state.error = payload;
    state.formLoading = false;
  },
  [SAVE_USER_SUCCESS](state, payload) {
    state.user = payload;
    state.formLoading = false;
    state.success = true;
  },

  [SAVE_PASSWORD](state) {
    state.error = false;
    state.formLoading = true;
    state.success = false;
  },
  [SAVE_PASSWORD_ERROR](state, payload) {
    state.error = payload;
    state.formLoading = false;
  },
  [SAVE_PASSWORD_SUCCESS](state, payload) {
    state.user = payload;
    state.success = true;
    state.formLoading = false;
  },

  [SAVE_USER_SIMPLE](state) {
    state.error = false;
    state.success = false;
    state.formLoading = true;
  },
  [SAVE_USER_SIMPLE_ERROR](state, payload) {
    state.error = payload;
    state.formLoading = false;
  },
  [SAVE_USER_SIMPLE_SUCCESS](state, payload) {
    state.user = payload;
    state.success = true;
    state.formLoading = false;
  },

  // single object item mutation
  updateItem(state, payload) {
    state.user[payload.item] = payload.value;
  },
};



// WEBPACK FOOTER //
// ./src/components/Users/mutations.js